export const getQueryBaseKey = (wrapperOptions, type) => [wrapperOptions, type];
export const getQueryKey = (wrapperOptions, params) => [
    ...getQueryBaseKey(wrapperOptions, 'query'),
    JSON.stringify(params, (_key, value) => value instanceof Set ? [...value] : value),
];
export const getInfiniteQueryKey = (wrapperOptions, staticParams) => [
    ...getQueryBaseKey(wrapperOptions, 'infiniteQuery'),
    staticParams,
];
export const getBatchQueryKey = (wrapperOptions, params) => [...getQueryBaseKey(wrapperOptions, 'batchQuery'), params];
